import { render, staticRenderFns } from "./oulandApproval.vue?vue&type=template&id=0c6015a8&scoped=true"
import script from "./oulandApproval.vue?vue&type=script&lang=js"
export * from "./oulandApproval.vue?vue&type=script&lang=js"
import style0 from "./oulandApproval.vue?vue&type=style&index=0&id=0c6015a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6015a8",
  null
  
)

export default component.exports